import { getPinnedLeadingFieldCountFromProperties } from './pinned-leading-view-properties.ts';

export function getPinnedLeadingAddEntryScrollLeft({
  currentScrollLeft,
  isEnabled,
  isTableLayout,
  viewProperties
}: {
  currentScrollLeft: number;
  isEnabled: boolean;
  isTableLayout: boolean;
  viewProperties: Readonly<Record<string, unknown>> | undefined;
}): number {
  const pinnedLeadingFieldCount =
    getPinnedLeadingFieldCountFromProperties(viewProperties) ?? 0;

  return isEnabled && isTableLayout && pinnedLeadingFieldCount > 0
    ? currentScrollLeft
    : 0;
}
